/**
 * 应用配置管理工具
 * 用于管理从 appdetail 接口获取的配置项
 */

const CONFIG_KEY = 'appConfig';

/**
 * 获取本地存储的应用配置
 * @returns {Object|null} 配置对象或null
 */
export function getLocalAppConfig() {
  try {
    const config = localStorage.getItem(CONFIG_KEY);
    return config ? JSON.parse(config) : null;
  } catch (error) {
    // console.error('解析本地配置失败:', error);
    return null;
  }
}

/**
 * 获取特定配置项
 * @param {string} key 配置项键名
 * @param {*} defaultValue 默认值
 * @returns {*} 配置项值或默认值
 */
export function getConfigItem(key, defaultValue = null) {
  const config = getLocalAppConfig();
  return config && config[key] !== undefined ? config[key] : defaultValue;
}

/**
 * 设置应用配置到本地存储
 * @param {Object} config 配置对象
 */
export function setAppConfig(config) {
  try {
    localStorage.setItem(CONFIG_KEY, JSON.stringify(config));
  } catch (error) {
    // console.error('保存配置到本地存储失败:', error);
  }
}

/**
 * 清除应用配置
 */
export function clearAppConfig() {
  localStorage.removeItem(CONFIG_KEY);
}

/**
 * 检查配置是否存在
 * @returns {boolean} 配置是否存在
 */
export function hasAppConfig() {
  return localStorage.getItem(CONFIG_KEY) !== null;
}

/**
 * 获取配置的更新时间
 * @returns {string|null} 更新时间或null
 */
export function getConfigUpdateTime() {
  const config = getLocalAppConfig();
  return config && config.updateTime ? config.updateTime : null;
}

/**
 * 检查配置是否需要更新
 * @param {number} maxAge 最大缓存时间（毫秒），默认24小时
 * @returns {boolean} 是否需要更新
 */
export function shouldUpdateConfig(maxAge = 24 * 60 * 60 * 1000) {
  const updateTime = getConfigUpdateTime();
  if (!updateTime) return true;
  
  const now = new Date().getTime();
  const configTime = new Date(updateTime).getTime();
  return (now - configTime) > maxAge;
}
